import React from 'react';
import { isSet } from '../../../../Utils/CommonFunctions';
// import elementsProperties from './elementsProperties';


const Padding = (props)=>{
    const {path,keyParam,elementData} = props;
    let paddingValueArr = [];
    let paddingValue = isSet(elementData.attributes.style[props.keyParam],null)!==null?elementData.attributes.style[props.keyParam]:'10px 10px 10px 10px'; 
    paddingValueArr = paddingValue.split(' ');
    let paddingTopValue = paddingValueArr[0]; 
    paddingTopValue = paddingTopValue.match(/\d/g);
    paddingTopValue = paddingTopValue.join("");

    let paddingRightValue = paddingValueArr[1]; 
    paddingRightValue = paddingRightValue.match(/\d/g);
    paddingRightValue = paddingRightValue.join("");

    let paddingBottomValue = paddingValueArr[2]; 
    paddingBottomValue = paddingBottomValue.match(/\d/g);
    paddingBottomValue = paddingBottomValue.join("");

    let paddingLeftValue = paddingValueArr[3]; 
    paddingLeftValue = paddingLeftValue.match(/\d/g);
    paddingLeftValue = paddingLeftValue.join("");    

    const changeHandler = (e,paddingType,padIndex) => {
        // let assignPadArr = [];
        const {value} = e.target;
        let valuePx = value+'px';
        paddingValueArr[padIndex] = valuePx;
        //console.log('paddingValueArr==',paddingValueArr)
        let paddingString = paddingValueArr.join(' ');
        //console.log('paddingString==',paddingString)
        props.changeHandler(path,keyParam,paddingString);
    }  

    return(
        <div className="w-100">
            <div className="input-group mb-3">  
                <div className="input-group-prepend">
                    <span className="input-group-text text-truncate" style={{minWidth:'100px'}}>Top</span>
                </div>              
                <input type="number" className="form-control" value={paddingTopValue} onChange={e=>changeHandler(e,'top',0)} />
                <div className="input-group-append">
                    <span className="input-group-text"> px </span>                    
                </div>
            </div>
            <div className="input-group mb-3">
                <div className="input-group-prepend">
                    <span className="input-group-text text-truncate" style={{minWidth:'100px'}}>Right</span>
                </div>                
                <input type="number" className="form-control" value={paddingRightValue} onChange={e=>changeHandler(e,'right',1)} />
                <div className="input-group-append">
                    <span className="input-group-text"> px </span>                    
                </div>
            </div> 
            <div className="input-group mb-3">
                <div className="input-group-prepend">
                    <span className="input-group-text text-truncate" style={{minWidth:'100px'}}>Bottom</span>
                </div>                
                <input type="number" className="form-control" value={paddingBottomValue} onChange={e=>changeHandler(e,'bottom',2)} />
                <div className="input-group-append">
                    <span className="input-group-text"> px </span>                    
                </div>
            </div> 
            <div className="input-group mb-3">
                <div className="input-group-prepend">
                    <span className="input-group-text text-truncate" style={{minWidth:'100px'}}>Left</span>
                </div>                
                <input type="number" className="form-control" value={paddingLeftValue} onChange={e=>changeHandler(e,'left',3)} />
                <div className="number-group-append">
                    <span className="input-group-text"> px </span>                    
                </div>
            </div>                     
        </div>
    )
}


export default Padding;